export default [
    {
        id: 1,
        avatar: "https://i.pravatar.cc/150?img=1",
        name: "Vansh Saini",
        role: "Worked Desk 1",
        projects: ["SG", "PQ", "CB"],
        manual: "0:41:00", 
        duration: "9:10:12",
        activity: 50, 
        notes: 5,
        details: [
            {
                date: "Tue, Apr 1, 2025",
                code: "SG",
                name: "John Doe",
                avatar: "https://i.pravatar.cc/150?img=2", // Optional image URL
                desk: "Social Media Strategist",
                manualHours: "0:41:00",
                started: "10:39 am",
                stopped: "3:13 pm",
                duration: "4:33:33",
                activity: 50, 
                notes: "2 Notes"
            },
            {
                date: "",
                code: "PQ",
                name: "Jane Smith", // No avatar - will show initials "JS"
                avatar: "https://i.pravatar.cc/150?img=3",
                desk: "UX Designer",
                 manualHours: "0:41:00",
                started: "10:39 am",
                stopped: "3:13 pm",
                duration: "4:33:33",
                activity: 50, 
                notes: "-"
            },
            {
                date: "",
                name: "Alice", // No avatar or code - will show initial "A"
                 code: "A",
                desk: "Product Manager",
               manualHours: "0:41:00",
                started: "10:39 am",
                stopped: "3:13 pm",
                duration: "4:33:33",
                activity: 60, 
                notes: "3 Notes"
            }
        ]
    },
    {
        id: 2,
        avatar: "https://i.pravatar.cc/150?img=4",
        name: "Dianne Russell",
        role: "Worked Desk 2",
        projects: ["SG", "PQ", "CB"],
        manual: "113:27:25", 
        duration: "113:27:25",
        activity: 50,
        idle: 11,
        notes: 5,
        details: [
            {
                date: "Tue, Apr 1, 2025",
                code: "SG",
                name: "John Doe",
                avatar: "https://i.pravatar.cc/150?img=5", // Optional image URL
                desk: "Product Manager",
                manualHours: "0:41:00",
                started: "10:39 am",
                stopped: "3:13 pm",
                duration: "4:33:33",
                activity: 50, 
                notes: "2 Notes"
            },
            {
                date: "",
                code: "PQ",
                name: "Jane Smith", // No avatar - will show initials "JS"
                avatar: "https://i.pravatar.cc/150?img=6",
                desk: "SEO Specialist",
                manualHours: "0:41:00",
                started: "10:39 am",
                stopped: "3:13 pm",
                duration: "4:33:33",
                activity: 50, 
                notes: "-"
            },
            {
                date: "",
                name: "Alice", // No avatar or code - will show initial "A"
                 code: "A",
                avatar: "https://i.pravatar.cc/150?img=7",
                desk: "Social Media Strategist",
                manualHours: "0:41:00",
                started: "10:39 am",
                stopped: "3:13 pm",
                duration: "4:33:33",
                activity: 60, 
                notes: "3 Notes"
            }
        ]
    },
];